import React, { useState } from 'react';
import { connect } from 'dva';
import styles from './CreateCollectionModal.module.scss';
import Button from '../../Button';
import ghAnalytics from '../../../lib/analytics';
import AlertCircle from '../../../assets/svg/Feather/AlertCircle';
import HuntsIcon from '../../../assets/svg/HuntsIcon';
import { COLORS } from '../../../lib/constants';

function CreateCollectionModal(props) {
  const [collectionName, setCollectionName] = useState('');

  const closeModal = (e) => {
    e.preventDefault();

    props.dispatch({
      type: 'modals/close',
    });
  };

  const createCollection = (e) => {
    props.dispatch({ type: 'modals/close' });
    props.dispatch({
      type: 'collections/setCollectionsLoading',
      payload: true,
    }),

    props.dispatch({
      type: 'toast/show',
      payload: {
        text: `Creating hunt "${collectionName}"...`,
        loader: true,
      },
    });

    props.dispatch({
      type: 'collections/createCollectionEffect',
      payload: collectionName,
      callback: (collectionId) => {
        props.dispatch({ type: 'modals/close' });
        if (collectionId) {
          props.dispatch({
            type: 'collections/getCollectionEffect',
            payload: collectionId,
            callback: (collection) => {
              props.dispatch({
                type: 'collections/addNewHuntToUserData',
                payload: collection,
              });
            }
          })
          ghAnalytics.logCollectionCreated(collectionId, collectionName);
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: `Created ${collectionName}`,
              icon: HuntsIcon,
              iconColor: COLORS.ghOrange,
            },
          });
          setTimeout(() => {
            props.dispatch({
              type: 'toast/dismiss',
            });
          }, 3500);
        } else {
          props.dispatch({
            type: 'toast/show',
            payload: {
              text: 'There was an issue and your hunt was not saved.',
              icon: AlertCircle,
              iconColor: '#ff3b30',
              dismissable: true,
            },
          });
        }
        props.dispatch({
          type: 'collections/setCollectionsLoading',
          payload: false,
        })
      },
    });
  };

  const collectionNameInput = (e) => {
    setCollectionName(e.target.value)
  };

  return (
    <div className={styles.createModal}>
      <div className={styles.header}>Create Hunt</div>
      <input
        type='text'
        placeholder='Hunt name'
        onChange={collectionNameInput}
        value={collectionName}
      ></input>
      <div className={styles.footerButtons}>
        <Button onClick={closeModal} theme={Button.THEME.outlinePrimary}>
          Cancel
        </Button>
        <Button onClick={createCollection} theme={Button.THEME.solidPrimary} disabled={!collectionName}>
          Save
        </Button>
      </div>
    </div>
  );
}

export default connect(() => ({}))(CreateCollectionModal);
